import { isMobileWidth } from '../../theme/layoutUtilities';
import {
    ETF_ASSET_CLASS_TYPES,
    TRANSPARENCY_TYPES
} from '../../utils/constants';
import { isAllocationFund } from '../../utils/fund-info';
// import { getEndOfMonthDates, parseAvailableDates } from './dateUtils';
import { getDropdownDates } from './compliantDateUtils';
import { getHeaders } from './agGridUtils';

import dataBuilder from './dataBuilder';

export const PERIOD = {
    MONTHLY_VAL: 'month',
    QUARTERLY_VAL: 'quarter'
};

export const allHoldingsUtil = (firstSelectableDate) => (gqlResult) => {
    if (!gqlResult) return null;

    const {
        name,
        inceptionDate,
        fullHoldings: { asOfDate, individualHoldings: holdings },
        assetClassName: assetTypeName,
        broadAssetClass,
        investmentStyleName,
        bond,
        transparencyTypeName
    } =
        gqlResult.exchangeTradedFund || gqlResult.mutualFund || {};

    const isMonthly = transparencyTypeName !== TRANSPARENCY_TYPES.FULL;
    const isFixedIncome =
        bond ||
        isAllocationFund(broadAssetClass, investmentStyleName) ||
        assetTypeName === ETF_ASSET_CLASS_TYPES.FIXED_INCOME;

    const { agData, csvData } = dataBuilder(
        holdings,
        isFixedIncome,
        isMonthly,
        asOfDate
    );

    const endOfMonthDates = getDropdownDates(
        isMonthly,
        inceptionDate,
        firstSelectableDate
    );

    const headers = getHeaders(isFixedIncome, isMonthly);

    return {
        name,
        agData,
        csvData,
        headers,
        tableConfigs: {
            props: {
                headerHeight: isMobileWidth() ? 65 : 56
            }
        },
        endOfMonthDates,
        isMonthly,
        asOfDate
    };
};
